import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { TableCellText } from '../TableCellText/index.js';
import { jsx } from 'react/jsx-runtime';

function TableCellEmpty(props) {
  return /*#__PURE__*/jsx(TableCellText, _extends({
    "aria-hidden": "true",
    primary: "-"
  }, props));
}

export { TableCellEmpty };
